import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-[15px] sm:gap-[20px]" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-3 gap-[15px] md:gap-[20px] mt-[15px] md:mt-[20px] items-center" }
const _hoisted_5 = { class: "md:col-span-2" }
const _hoisted_6 = {
  class: "relative md:-top-[5px] md:pt-[2px] ltr:pl-[50px] rtl:pr-[50px] ltr:md:pl-[71px] rtl:md:pr-[71px]",
  id: "priceRangeSlider"
}
const _hoisted_7 = {
  id: "rangeSlider",
  class: "range-slider"
}
const _hoisted_8 = { class: "number-group flex items-center justify-between" }
const _hoisted_9 = ["min", "max"]
const _hoisted_10 = ["min", "max"]
const _hoisted_11 = { class: "range-group relative -mt-[10px] ltr:ml-[32px] rtl:mr-[32px] ltr:mr-[53px] rtl:ml-[53px]" }
const _hoisted_12 = ["min", "max"]
const _hoisted_13 = ["min", "max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }, [
      _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Filter")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              class: "h-[44px] rounded-md text-black dark:text-white bg-gray-50 dark:bg-[#0a0e19] px-[17px] block w-full outline-0 placeholder:text-gray-500 dark:placeholder:text-gray-400",
              placeholder: "Search"
            }, null, 512), [
              [_vModelText, _ctx.search]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.category) = $event)),
              class: "h-[44px] rounded-md bg-gray-50 dark:bg-[#0a0e19] px-[13px] block w-full outline-0 cursor-pointer"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("option", { value: "" }, "Category", -1),
              _createElementVNode("option", null, "Bird", -1),
              _createElementVNode("option", null, "Pool", -1),
              _createElementVNode("option", null, "Watermelon", -1),
              _createElementVNode("option", null, "Flower", -1),
              _createElementVNode("option", null, "Cookies", -1)
            ]), 512), [
              [_vModelSelect, _ctx.category]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fileType) = $event)),
              class: "h-[44px] rounded-md bg-gray-50 dark:bg-[#0a0e19] px-[13px] block w-full outline-0 cursor-pointer"
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("option", { value: "" }, "File Type", -1),
              _createElementVNode("option", null, ".zip", -1),
              _createElementVNode("option", null, ".jpg", -1),
              _createElementVNode("option", null, ".png", -1),
              _createElementVNode("option", null, ".gif", -1),
              _createElementVNode("option", null, ".pdf", -1)
            ]), 512), [
              [_vModelSelect, _ctx.fileType]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.salesType) = $event)),
              class: "h-[44px] rounded-md bg-gray-50 dark:bg-[#0a0e19] px-[13px] block w-full outline-0 cursor-pointer"
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("option", { value: "" }, "Sales Type", -1),
              _createElementVNode("option", null, "Bird", -1),
              _createElementVNode("option", null, "Pool", -1),
              _createElementVNode("option", null, "Watermelon", -1),
              _createElementVNode("option", null, "Flower", -1),
              _createElementVNode("option", null, "Cookies", -1)
            ]), 512), [
              [_vModelSelect, _ctx.salesType]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "block font-semibold absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2" }, " Price: ", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    class: "number-input md:text-md font-semibold text-gray-900 dark:text-gray-400 dark:bg-[#0c1427] !outline-0",
                    type: "number",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.price.min) = $event)),
                    min: _ctx.range.min,
                    max: _ctx.price.max
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.price.min]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "number-input md:text-md font-semibold text-gray-900 dark:text-gray-400 dark:bg-[#0c1427] !outline-0 text-right",
                    type: "number",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.price.max) = $event)),
                    min: _ctx.price.min,
                    max: _ctx.range.max
                  }, null, 8, _hoisted_10), [
                    [_vModelText, _ctx.price.max]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    class: "range-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.price.min) = $event)),
                    min: _ctx.range.min,
                    max: _ctx.range.max,
                    step: "1",
                    type: "range"
                  }, null, 8, _hoisted_12), [
                    [_vModelText, _ctx.price.min]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "range-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.price.max) = $event)),
                    min: _ctx.range.min,
                    max: _ctx.range.max,
                    step: "1",
                    type: "range"
                  }, null, 8, _hoisted_13), [
                    [_vModelText, _ctx.price.max]
                  ])
                ])
              ])
            ])
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "md:col-span-1 ltr:md:text-right rtl:md:text-left" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "inline-block md:text-md font-medium bg-primary-500 text-white rounded-[7px] py-[6px] px-[25px] md:px-[53px] hover:bg-primary-400 mt-[8px] md:mt-0"
            }, " Filter ")
          ], -1))
        ])
      ], 32)
    ])
  ]))
}